/**
 * Resolve the website origin for the env this SPA is running in.
 *
 * `admin.podecontratar.com.br`         → `https://podecontratar.com.br`
 * `admin.staging.podecontratar.com.br` → `https://staging.podecontratar.com.br`
 * `localhost:3001`                      → `http://localhost:3000`
 *
 * The host-derived form means one build works for prod and staging — we
 * don't have to bake the URL into the bundle at build time. SSR-safe
 * fallback returns the prod origin so unit tests don't blow up.
 */
export function websiteOrigin(): string {
  if (typeof window === "undefined") return "https://podecontratar.com.br";
  const host = window.location.hostname;
  if (host === "localhost" || host === "127.0.0.1") return "http://localhost:3000";
  return `${window.location.protocol}//${host.replace(/^admin\./, "")}`;
}
